import { useQuery } from '@tanstack/react-query';

import { fetchMcpOAuthGrants } from '@/api/v4/mcp-oauth.api';
import { QueryKey } from '@/config/query-client';
import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';

export const useMcpOAuthGrants = () => {
  const { userProducts } = useUserProducts();
  const hasClaudeMcpConnector = userProducts.includes(
    PRODUCT.CLAUDE_MCP_CONNECTOR,
  );
  const hasPersonalAccessToken = userProducts.includes(
    PRODUCT.PERSONAL_ACCESS_TOKEN,
  );

  return useQuery({
    queryKey: [QueryKey.McpOAuthGrants],
    queryFn: fetchMcpOAuthGrants,
    enabled: hasClaudeMcpConnector && hasPersonalAccessToken,
    refetchInterval: query => {
      const hasWaitingGrant =
        query.state.data?.some(
          grant => !grant.lastUsedAt && !grant.lastError,
        ) ?? false;

      return hasWaitingGrant ? 5000 : false;
    },
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
};
